interface StateProps {
  mobile: string | undefined
}

export const saveLocationToStorage = (key: string, state: StateProps) => {
  localStorage.setItem(key, JSON.stringify(state))
}

export const getLocationFromStorage = (key: string) => {
  const storedState = localStorage.getItem(key)
  return storedState ? JSON.parse(storedState) : null
}

export const clearLocationFromStorage = (key: string) => {
  localStorage.removeItem(key)
}
